(function() {
  define('tlhServicesScroll',['angular'], function() {
    'use strict';
    return angular.module('tlhServicesScroll', []).factory('TlhScrollService', [
      '$timeout', function($timeout) {
        var factory;
        factory = {};
        factory.getTop = function() {
          var doc;
          doc = document.documentElement;
          return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
        };
        factory.setTop = function(top) {
          return $timeout(function() {
            return document.documentElement.scrollTop = document.body.scrollTop = top;
          });
        };
        return factory;
      }
    ]);
  });

}).call(this);

//# sourceMappingURL=scroll.js.map
;
